import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  container: {
    textAlign: 'center',
    width: '19.2rem',
    '@media (min-width: 1401px)': {
      width: '24rem'
    }
  },
  root: {
    alignItems: 'center',
    color: theme.palette.secondary.main,
    display: 'flex',
    justifyContent: 'center',
    height: '100%'
  },
  title: {
    fontSize: '3.84rem',
    margin: 'auto',
    '@media (min-width: 701px)': {
      fontSize: '4.8rem'
    },
    '@media (min-width: 1401px)': {
      fontSize: '6rem'
    }
  },
  text: {
    fontSize: '0.96rem',
    margin: 'auto',
    '@media (min-width: 701px)': {
      fontSize: '1.2rem'
    },
    '@media (min-width: 1401px)': {
      fontSize: '1.5rem'
    }
  }
}));

const NotFound = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
          <div className={classes.container}>
            <h1 className={classes.title}>404</h1>
            <p className={classes.text}>¿Esta no es la página que estabas buscando?</p>
          </div>
        </div>
    );
};

export default NotFound;